export * from './copywrite.component';


// WEBPACK FOOTER //
// ./resources/assets/typescript/_copywrite/index.ts